<template>
    <div>
        <slot v-bind:auth="auth"></slot>
    </div>
</template>

<script>

export default {
    data() {
        return {
            auth: this.get_controller('auth')
        }
    }
}
</script>